import React from 'react';
import { Container, Section } from '../components/ui/Section';
import { ButtonLink } from '../components/ui/Button';
export function NotFound() {
  return <Section className="bcm-paper py-20 sm:py-28" data-id="element-556" data-mp="w6dohvu55851">
      <Container className="max-w-2xl" data-id="element-557" data-mp="105la7jf48ucy">
        <p className="font-meta text-xs font-semibold uppercase tracking-[0.18em] text-brand-navy" data-id="element-558" data-mp="107z77xtcwgn5">
          Page not found
        </p>
        <h1 className="mt-3 font-display text-4xl font-extrabold tracking-tight text-brand-navy sm:text-5xl" data-id="element-559" data-mp="1a4anszzzbsne">
          This page moved, but you’re still welcome.
        </h1>
        <p className="mt-5 font-sans text-[17px] leading-relaxed text-ink" data-id="element-560" data-mp="1f0sn3kcjiysc">
          BCM meets Thursdays at 7:30 PM during the school year. Start on the homepage or check what
          is coming up next.
        </p>
        <div className="mt-8 flex flex-col gap-3 sm:flex-row" data-id="element-561" data-mp="1susc8sds422y">
          <ButtonLink to="/" data-id="element-562" data-mp="1ssfjdk6hg7b4">Back to Home</ButtonLink>
          <ButtonLink to="/events" variant="secondary" data-id="element-563" data-mp="1xstvbdb7g1ef">
            See Events
          </ButtonLink>
        </div>
      </Container>
    </Section>;
}